import { Injectable } from '@angular/core';
import {
  BoxxImagePickerMobileCamera,
  BoxxImagePickerMobilePicker,
  BoxxImagePickerPWAPicker,
  BoxxWebBrowserPickerOptions,
} from '@boxx/boxx-images';
import { ActionSheetController, Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  BoxxImageConstraints,
  BoxxImageModel,
} from '../models/BoxxImage.model';
import { BoxxUtilsService } from 'src/services/BoxxUtils.service';
import { BottomSheetType } from '@app/components/bottom-sheet/bottom-sheet.model';

@Injectable()
export class BoxxImagePickerSourceService {
  promiseResolve: (
    value: BoxxImageModel[] | PromiseLike<BoxxImageModel[]> | number
  ) => void;

  promisePixaBayResolve: (
    value: any
  ) => void;

  promiseReject: (reason?: any) => void;

  private isMobileDevice = false;

  private imageConstraints: BoxxImageConstraints = {};

  private pickerOptions: BoxxWebBrowserPickerOptions = {};

  private readonly defaultImageConstraints: BoxxImageConstraints = {
    maxBytes: 5 * 1000 * 1000, //convert to Mb,
  };

  private translations: any;
  private destroyed$ = new Subject<boolean>();
  private isIos = false;

  constructor(
    private actionSheetCtrl: ActionSheetController,
    private pwaImagePicker: BoxxImagePickerPWAPicker,
    private mobileImageCamera: BoxxImagePickerMobileCamera,
    private mobileImagePicker: BoxxImagePickerMobilePicker,
    platform: Platform,
    translate: TranslateService,
    public boxxUtils: BoxxUtilsService
  ) {
    platform.ready().then(() => {
      this.isMobileDevice = platform
        .platforms()
        .some((p) => ['cordova', 'capacitor'].includes(p));

      this.isIos = platform
        .platforms()
        .some((name) => ['ios', 'ipad', 'iphone'].includes(name));
    });

    translate
      .get(['BUSINESS_FORMS', 'ACTIONS', 'ERRORS', 'SUCCESS'])
      .pipe(takeUntil(this.destroyed$))
      .subscribe((t) => (this.translations = t));
  }

  setImageConstraints(constraints: BoxxImageConstraints) {
    this.imageConstraints = constraints;
    return this;
  }

  setPickerOptions(
    options: BoxxWebBrowserPickerOptions
  ) {
    this.pickerOptions = options;
    return this;
  }

  async showImagePickerSources(): Promise<BoxxImagePickerSourceService> {
    return new Promise(async (resolve) => {
    let dataPicker = [
      {
        key: 'gallery',
        value: 'BUSINESS_FORMS.WEBPAGE.ACTION_SHEET.BUTTONS.fromDeviceText',
        icon: 'image',
        icon_type: 'name',
        class: 'custom'
      },
      {
        key: 'pixabay',
        value: 'BUSINESS_FORMS.WEBPAGE.ACTION_SHEET.BUTTONS.fromPixabay',
        icon: 'search',
        icon_type: 'name',
        class: 'custom'
      }
    ];

    if (this.isMobileDevice) {
      dataPicker.push(
        {
          key: 'photo',
          value: 'BUSINESS_FORMS.WEBPAGE.ACTION_SHEET.BUTTONS.takePhoto',
          icon: 'camera',
          icon_type: 'name',
          class: 'custom'
        }
      );
    }

    this.boxxUtils.openBottomSheet({
      data: dataPicker,
      type: BottomSheetType.options,
      initialBreakpoint: 1,
      breakpoints: [0, 1],
      canClose: true,
      title: 'BUSINESS_FORMS.WEBPAGE.ACTION_SHEET.header',
      maxHeigth: 30
    }).then((data) => {
      if (data?.value) {
        console.log('data?.value: ', data?.value);
        if (data?.value === 'gallery') {
          //return new Promise(async (resolve) => {
            resolve(this);
            if (this.isMobileDevice) {
              this.pickImagesFromMobile();
            } else {
              this.pickImagesFromWebBrowser();
            }
          //});
        }
        else if (data?.value === 'pixabay') {
          //return new Promise(async (resolve) => {
            resolve(this);
            setTimeout(() => {
              this.promiseResolve(0);
            }, 800);
          //});
        }
        else if (data?.value === 'photo') {
          //return new Promise(async (resolve) => {
            resolve(this);
            this.takePhoto();
          //});
        }
      }
    });
  });


    // return new Promise(async (resolve) => {
    //   const buttons = [
    //     {
    //       text: this.translations.BUSINESS_FORMS.WEBPAGE.ACTION_SHEET.BUTTONS
    //         .fromDeviceText,
    //       icon: this.isIos ? '' : './assets/icon/Icon_DevicesAddImage.svg',
    //       handler: () => {
    //         resolve(this);
    //         if (this.isMobileDevice) {
    //           this.pickImagesFromMobile();
    //         } else {
    //           this.pickImagesFromWebBrowser();
    //         }
    //       },
    //     },
    //     {
    //       text: this.translations.BUSINESS_FORMS.WEBPAGE.ACTION_SHEET.BUTTONS.fromPixabay,
    //       icon: 'images-outline',
    //       handler: () => {
    //         resolve(this);
    //         setTimeout(() => {
    //           this.promiseResolve(0);
    //         }, 800);
    //       },
    //     },
    //     /* {
    //       text: 'From Web',
    //       handler: () => {
    //         resolve(this);
    //         //todo: open view and load wit API
    //       },
    //     }, */
    //   ];

    //   if (this.isMobileDevice) {
    //     buttons.unshift({
    //       text: this.translations.BUSINESS_FORMS.WEBPAGE.ACTION_SHEET.BUTTONS
    //         .takePhoto,
    //       icon: this.isIos ? '' : 'camera',
    //       handler: () => {
    //         resolve(this);
    //         this.takePhoto();
    //       },
    //     });
    //   }

    //   const actionSheet = await this.actionSheetCtrl.create({
    //     header: this.translations.BUSINESS_FORMS.WEBPAGE.ACTION_SHEET.header,
    //     buttons,
    //   });

    //   await actionSheet.present();
    // });
  }

  async takePhoto() {
    const images = await this.mobileImageCamera
      .setImageConstraints({
        ...this.defaultImageConstraints,
        ...this.imageConstraints,
      })
      .setPickerOptions(this.pickerOptions as any)
      .pickImages();

    this.resetConstraintsAndPickerOptions();

    setTimeout(() => {
      this.promiseResolve(images);
    }, 800);
  }

  async pickImagesFromMobile() {
    const images = await this.mobileImagePicker
      .setImageConstraints({
        ...this.defaultImageConstraints,
        ...this.imageConstraints,
      })
      .setPickerOptions(this.pickerOptions)
      .pickImages();

    this.resetConstraintsAndPickerOptions();

    setTimeout(() => {
      this.promiseResolve(images);
    }, 800);
  }

  async pickImagesFromWebBrowser() {
    const images = await this.pwaImagePicker
      .setImageConstraints({
        ...this.defaultImageConstraints,
        ...this.imageConstraints,
      })
      .setPickerOptions(this.pickerOptions as BoxxWebBrowserPickerOptions)
      .pickImages();

    this.resetConstraintsAndPickerOptions();

    setTimeout(() => {
      this.promiseResolve(images);
    }, 800);
  }

  onSelectedValidImages(): Promise<BoxxImageModel[]> {
    return new Promise((resolve, reject) => {
      this.promiseResolve = resolve;
      this.promiseReject = reject;
    });
  }

  private resetConstraintsAndPickerOptions() {
    this.imageConstraints = {};
    this.pickerOptions = {};
  }
}
